import React from "react";
import CardTestimonials from "../../atoms/card-testimonials/card-testimonials";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./testimonials.scss";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const Testimonials = (props: ReferenciaContenido) => {
  const testimonialsData = props;
  const setting = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const { referenciaPlantillaContenido } = testimonialsData;
  return (
    <div className="m-testimonials">
      <Slider {...setting}>
        {referenciaPlantillaContenido.map((val, key) => {
          return (
            <div key={key}>
              <CardTestimonials className={`${"card" + (key + 1)}`}>
                <div className="m-testimonials__description">
                  <p>
                    {
                      JSON.parse(val.descripcion.raw).content[0].content[0]
                        .value
                    }
                  </p>
                  <div className="m-testimonials__description__author">
                    <p>
                      <strong>{val.tituloBanner}</strong>
                    </p>
                  </div>
                </div>
              </CardTestimonials>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Testimonials;
